import React from "react";
import "./ExcalidrawLogo.scss";

type LogoSize = "xs" | "small" | "normal" | "large" | "custom" | "mobile";

interface LogoProps {
  size?: LogoSize;
  withText?: boolean;
  style?: React.CSSProperties;
  isNotLink?: boolean;
}

export const ExcalidrawLogo = ({
  style,
  size = "small",
}: LogoProps) => {
  return (
    <div className={`ExcalidrawLogo is-${size} idraw-logo`} style={style}>
      <span className="idraw-logo-text">idraw</span>
    </div>
  );
};
